import { StrictMode } from "react";

import { createRoot } from "react-dom/client";

import { App } from "@/App";
import "@/styles/index.css";
// ⚠ AFTER Tailwind, deliberately. theme.css carries the validated component classes
// (.gradient-btn, .glass-card-login, .nav-item-active, .pill, .code-box) and they must win
// over Tailwind utilities of equal specificity — which is exactly the order the mockups
// load them in. A CSS @import inside index.css would NOT do this: @import is hoisted to the
// top of the file, putting the theme FIRST and letting utilities override it.
import "@/styles/theme.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing from index.html");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
